import {Component, OnInit} from '@angular/core';

import {AuthService} from './core/auth.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private authService: AuthService) {
  }

  ngOnInit() {
    let loginInfo = localStorage.getItem('idToken');
    if (loginInfo) {
      this.authService.isLoggedIn = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts